import {postApi, putApi, OK} from "../util";

const state = {
	apiStatus: null,
	paramMemoUpdate: null,
	editFlag: false
}

const mutations = {
	setApiStatus (state, status) {
		state.apiStatus = status
	},
	setEditFlag (state, flag) {
		state.editFlag = flag
	},
	setParamMemoUpdate(state, param) {
		state.paramMemoUpdate = param
	}
}

const actions = {
	// 新規登録
	async postMemoApi(context, data) {
		context.commit('setApiStatus', null)
		const response = await postApi('memo', data)
		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			return false
		}
		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, {root: true})
		context.commit('error/setMessage', response.message, {root: true})
	},
	// メモ更新
	async putMemoApi(context, data) {
		context.commit('setApiStatus', null)
		const response = await putApi('memo', data)
		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			return false
		}
		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, {root: true})
		context.commit('error/setMessage', response.message, {root: true})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
